import React from "react";
import { useSimulationStore } from "../../store/simulationStore";

export function PlayPauseControl() {
  const isPlaying = useSimulationStore((s) => s.isPlaying);
  const setPlaying = useSimulationStore((s) => s.setPlaying);
  const setDirection = useSimulationStore((s) => s.setDirection);
  const direction = useSimulationStore((s) => s.direction);

  return (
    <div className="tls-astro-control-block tls-astro-play-row">
      <button type="button" onClick={() => setPlaying(!isPlaying)}>
        {isPlaying ? "Pausar" : "Reproduzir"}
      </button>
      <button
        type="button"
        onClick={() => {
          setDirection(1);
          setPlaying(true);
        }}
      >
        Avançar
      </button>
      <button
        type="button"
        onClick={() => {
          setDirection(-1);
          setPlaying(true);
        }}
      >
        Retroceder
      </button>
      <span className="tls-astro-muted">
        {direction === 1 ? "→" : "←"}
      </span>
    </div>
  );
}
